// extracted by mini-css-extract-plugin
export default {"right-button":"update-admin-form_right-button__V0RSf","button":"update-admin-form_button__2xwOA"};